// extracted by mini-css-extract-plugin
export default {"form":"CreatePayment_form__FF-HN","selectedUserContainer":"CreatePayment_selectedUserContainer__Gj-KR","paymentFormContainer":"CreatePayment_paymentFormContainer__YpC27"};